import type { IFetchCardInfo } from "../types/api/order";

export const PAYMENT_METHOD = {
  카드: "CARD",
  간편결제: "EASY PAY",
  가상계좌: "VIRTUAL ACCOUNT",
  휴대폰: "MOBILE PHONE",
  계좌이체: "TRANSFER",
  문화상품권: "CULTURE GIFT CERTIFICATE",
  도서문화상품권: "BOOK GIFT CERTIFICATE",
  게임문화상품권: "GAME GIFT CERTIFICATE",
  토스페이: "TOSSPAY",
  토스결제: "TOSSPAY",
  네이버페이: "NAVERPAY",
  삼성페이: "SAMSUNGPAY",
  엘페이: "LPAY",
  카카오페이: "KAKAOPAY",
  페이코: "PAYCO",
  SSG페이: "SSG",
  애플페이: "APPLEPAY",
  핀페이: "PINPAY",
  페이팔: "PAYPAL",
  신용: "CREDIT CARD",
  DINERS: "DINERS",
  VISA: "VISA",
  MASTER: "MASTER",
  UNIONPAY: "UNIONPAY",
  AMEX: "AMEX",
  JCB: "JCB",
};

interface IProps {
  storeName: string;
  orderId: string;
  lang: "ko" | "en" | "jp";
}

export const fetchCardInfo = async ({ storeName, orderId, lang }: IProps): Promise<IFetchCardInfo | undefined> => {
  const lambdaUrl = `https://dui34irep3ubtw4oehmguqf2f40xqjtc.lambda-url.ap-northeast-2.on.aws/?orderId=${orderId}&storeName=${storeName}&lang=${lang}`;

  try {
    const response = await fetch(lambdaUrl).then((res) => res);
    if (response.status === 200) {
      return (await response.json()) as IFetchCardInfo;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
